import { render, staticRenderFns } from "./MyInsight.vue?vue&type=template&id=ebf70338&scoped=true&"
import script from "./MyInsight.vue?vue&type=script&lang=js&"
export * from "./MyInsight.vue?vue&type=script&lang=js&"
import style0 from "./MyInsight.vue?vue&type=style&index=0&id=ebf70338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf70338",
  null
  
)

export default component.exports